// import React, { useEffect, useState } from "react"
// import logo from "../../assets/images/logo/site_logo.png"
// import StickyMenu from "../../lib/StickyMenu"
// // import Navigation from "../Navigation"
// import { Link } from "react-router-dom"

// function HeaderHomeThree({ action }) {

//   useEffect(() => {
//     StickyMenu()
//   })
//   return (
//     <>
//       <header className="appie-header-area appie-header-3-area appie-sticky">
//         <div className="container">
//           <div className="header-nav-box header-nav-box-3">
//             <div className="row align-items-center">
//               <div className="col-lg-2 col-md-4 col-sm-5 col-6 order-1 order-sm-1">
//                 <div className="appie-logo-box">
//                   <Link to="/" className="mainLogo">
//                     <img src={logo} alt="" />
//                   </Link>
//                 </div>
//               </div>
//               <div className="col-lg-6 col-md-1 col-sm-1 order-3 order-sm-2">
//                 {/* <div className="appie-header-main-menu">
//                   <Navigation />
//                 </div> */}
//               </div>
//               <div className="col-lg-4  col-md-7 col-sm-6 col-6 order-2 order-sm-3">
//                 <div className="appie-btn-box text-right">
//                   {/* <Link className="login-btn" to="/login">
//                     <i className="fal fa-user" /> Provider Login
//                   </Link> */}
//                   <Link
//                     className="main-btn ml-30 float-end"
//                     to="/login"
//                     style={{ background: "transparent", color: "#ff6b58" }}
//                   >
//                     {/* <i className="fal fa-user me-1 " />{" "} */}
//                     <span className="loginBtnText">Provider</span> Login
//                   </Link>
//                   {/* <div
//                     onClick={(e) => action(e)}
//                     className="toggle-btn ml-30 canvas_open d-lg-none d-block"
//                   >
//                     <i className="fa fa-bars" />
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//     </>
//   )
// }

// export default HeaderHomeThree

import React, { useEffect, useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText
} from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import logo from "../../assets/images/logo/site_logo.png"
import StickyMenu from "../../lib/StickyMenu"

function HeaderHomeThree(args) { 
  const [isOpen, setIsOpen] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992)

  const location = useLocation()

  console.log(location)

  useEffect(() => {
    StickyMenu()

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const toggle = () => setIsOpen(!isOpen)

  return (
    <>
      <header className={isSmallScreen ? "appie-header-area.is-for-small-screen appie-header-3-area appie-sticky" : "appie-header-area appie-header-3-area appie-sticky"} >
        <div className={isSmallScreen ? "container ps-0 pe-0" : "container"}>
          <Navbar
            expand="lg"
            className={isSmallScreen ? "px-0 header-class-for-small-screen" : "px-0"} 
            style={{
              textAllign: "right"
            }}
          >
            <NavbarBrand href="/" className="appie-logo-box">
              <span to="/" className="mainLogo">
                <img src={logo} alt="" />
              </span>
            </NavbarBrand>

            <NavbarToggler
              onClick={toggle}
              className="text-white"
              style={{
                width: "45px",
                border: "none",
                boxShadow: "none",
                position: "relative",
                right: 24,
                top: -12
              }}
            >
              <span
                className="w-100 p-0"
                style={{
                  backgroundColror: "white",
                  border: "1px solid white",
                  position: "absolute",
                  top: 0
                }}
              ></span>
              <span
                className="w-100 p-0"
                style={{
                  backgroundColror: "white",
                  border: "1px solid white",
                  position: "absolute",
                  top: 15
                }}
              ></span>
              <span
                className="w-100 p-0"
                style={{
                  backgroundColror: "white",
                  border: "1px solid white",
                  position: "absolute",
                  top: 30
                }}
              ></span>
            </NavbarToggler>
            <Collapse
              isOpen={isOpen}
              navbar
              className="mb-1 mb-lg-0 text-center"
              style={{
                paddingTop: isSmallScreen ? "24px" : 0,
                textAllign: "center"
              }}
            >
              <Nav navbar className="justify-content-end w-100 ms-auto px-0">
                <NavItem>
                  <NavLink
                    href="/"
                    className="px-2"
                    style={{
                      fontSize: "18px",
                      color: location.pathname === "/" ? "#54b5ff" : "white"
                    }}
                  >
                    Home
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="/explore"
                    className="px-2"
                    style={{
                      fontSize: "18px",
                      color:
                        location.pathname === "/explore" ? "#54b5ff" : "white"
                    }}
                  >
                    Explore
                  </NavLink>
                </NavItem>
                {/* <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="text-white">
                    Options
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem>Option 1</DropdownItem>
                    <DropdownItem>Option 2</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>Reset</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
              </Nav>

              {/* <NavbarText>
                <Link
                  to="/login"
                  className={`main-btn ${isSmallScreen ? "mt-2" : ""}`}
                  style={{
                    background: "transparent",
                    border: "1px solid #ff6b58",
                    color: "#ff6b58",
                    borderRadius: "6px",
                    textDecoration: "none"
                  }}
                >
                  Provider Login
                </Link>
              </NavbarText> */}
            </Collapse>
          </Navbar>
        </div>
      </header>
    </>
  )
}

export default HeaderHomeThree
